import { List, Minus, PanelBottom, PanelRight, PictureInPicture2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { DockMode } from "@/types/assistant.types";
import { useAssistantDock } from "../store";

// Spec (dock flutuante) — cabeçalho: ≡ histórico + Sparkles/título + segmented (direita/embaixo/
// flutuante) + minimizar (recolhe pro FAB). Segue o estilo da plataforma (tokens/shadcn).
const MODES: { mode: DockMode; label: string; Icon: typeof PanelRight }[] = [
  { mode: "right", label: "Ancorar à direita", Icon: PanelRight },
  { mode: "bottom", label: "Ancorar embaixo", Icon: PanelBottom },
  { mode: "floating", label: "Janela flutuante", Icon: PictureInPicture2 },
];

export function DockHeader({
  title,
  showList,
  onToggleList,
}: {
  title: string;
  showList: boolean;
  onToggleList: () => void;
}) {
  const setOpen = useAssistantDock((s) => s.setOpen);
  const mode = useAssistantDock((s) => s.mode);
  const setMode = useAssistantDock((s) => s.setMode);
  return (
    <header className="flex items-center gap-1 border-b border-border px-2 py-2">
      <Button
        variant="ghost"
        size="icon"
        aria-label={showList ? "Voltar à conversa" : "Histórico de conversas"}
        aria-pressed={showList}
        onClick={onToggleList}
      >
        <List className="h-4 w-4" />
      </Button>
      <Sparkles className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
      <h2 className="min-w-0 flex-1 truncate text-sm font-semibold text-foreground">{title}</h2>
      <div
        className="flex items-center rounded-md border border-border"
        role="group"
        aria-label="Estilo da janela"
      >
        {MODES.map(({ mode: m, label, Icon }) => (
          <Button
            key={m}
            variant="ghost"
            size="icon"
            aria-label={label}
            aria-pressed={mode === m}
            className={cn("h-7 w-7 rounded-none", mode === m && "bg-accent text-accent-foreground")}
            onClick={() => setMode(m)}
          >
            <Icon className="h-4 w-4" />
          </Button>
        ))}
      </div>
      <Button
        variant="ghost"
        size="icon"
        aria-label="Minimizar assistente"
        onClick={() => setOpen(false)}
      >
        <Minus className="h-4 w-4" />
      </Button>
    </header>
  );
}
